import {
    ADD_COLLABORATORS_OPERATION,
    REMOVE_COLLABORATORS_OPERATION,
    ADD_TAGS_OPERATION,
    REMOVE_TAGS_OPERATION
} from 'app/store/__generated__/operations';
import { replaceHash, parseSelectedCell } from 'app/routes';
import { selectEntityId, selectFilteredSchemaForPropEntityId } from './entities/selectors.js';
import {
    SELECT_CELL,
    ADD_USERS_TO_SPACE,
    DELETE_USERS_FROM_SPACE,
    ADD_TAGS,
    REMOVE_TAGS,
    SELECT_COLUMN_BY_NAME
} from './types.js';

export const doSelectCell = (cell) => ({
    type: SELECT_CELL,
    payload: cell,
    effect: ({ action }) => {
        const selectedCell = action.payload;
        const hashCell = parseSelectedCell(location);

        if (
            selectedCell?.rowIndex !== hashCell?.rowIndex ||
            selectedCell?.columnIndex !== hashCell?.columnIndex
        ) {
            replaceHash(`cell-${selectedCell.columnIndex}-${selectedCell.rowIndex}`);
        }
    }
});

export const doSelectColumnByName = (name) => ({
    type: SELECT_COLUMN_BY_NAME,
    effect: ({ store }) => {
        const { getState, dispatch } = store;
        const state = getState();

        const entityId = selectEntityId(state);
        const schema = selectFilteredSchemaForPropEntityId(state, { entityId });
        const index = schema.findIndex((column) => column.name === name);

        if (index >= 0) {
            dispatch(doSelectCell({ rowIndex: 0, columnIndex: index }));
        }
    }
});

export const doAddUserToSpace = ({ onFinish, ...params }) => ({
    type: ADD_USERS_TO_SPACE,
    api: ADD_COLLABORATORS_OPERATION,
    params,
    onFinish
});

export const doDeleteUserFromSpace = ({ onFinish, ...params }) => ({
    type: DELETE_USERS_FROM_SPACE,
    api: REMOVE_COLLABORATORS_OPERATION,
    params,
    onFinish
});

export const doAddTags = (params) => ({
    type: ADD_TAGS,
    api: ADD_TAGS_OPERATION,
    params
});

export const doRemoveTags = (params) => ({
    type: REMOVE_TAGS,
    api: REMOVE_TAGS_OPERATION,
    params
});
